import React, {FC} from 'react';
import format from 'date-fns/format';
import ReactDatePicker, {ReactDatePickerProps} from 'react-datepicker';
import {forwardRef, Input, InputGroup, InputProps, InputRightElement} from 'components/ui/chakra';
import {CalendarIcon} from 'components/ui/icons';
import 'react-datepicker/dist/react-datepicker.css';
import '../theme/date-picker.css';

interface DatePickerProps extends ReactDatePickerProps {
	placeholder?: string;
	dateFormat?: string;
	initialValue?: Date;
	inputProps: InputProps;
}

type DateInputProps = {
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	value?: string;
};

const DatePicker: FC<DatePickerProps> = ({
	placeholder,
	dateFormat = 'yyyy-MM-dd',
	value = '',
	inputProps,
	...props
}) => {
	const date = value ? new Date(value) : null;

	const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
		({value: inputValue, onClick, onChange}, ref) => (
			<InputGroup onClick={onClick}>
				<Input
					{...inputProps}
					bgColor='white'
					ref={ref}
					placeholder={placeholder ?? ''}
					value={inputValue}
					onChange={onChange}
					autoComplete='off'
				/>
				<InputRightElement>
					<CalendarIcon color='gray.500' />
				</InputRightElement>
			</InputGroup>
		),
	);

	return (
		<div className='light-theme'>
			<ReactDatePicker
				{...props}
				selected={date}
				value={date ? format(date, dateFormat) : ''}
				showPopperArrow={false}
				customInput={<DateInput />}
				dateFormat={dateFormat}
			/>
		</div>
	);
};

export default DatePicker;
